<template>
	<div>
		<b-modal
			@ok="emitOk"
			@hidden="emitHidden"
			@hide="emitBeforeHide"
			@cancel="emitCancel"
			:id="id"
			:title="title"
			:ok-title="okTitle"
			:ok-variant="okVariant"
			:cancel-title="cancelTitle"
			:cancel-variant="cancelVariant"
			:size="size"
			:ok-only="okOnly"
			:ok-disabled="okDisabled"
			:cancel-disabled="cancelDisabled"
			:hide-footer="hideFooter"
			centered
			:modal-class="customClass"
			:no-close-on-esc="noCloseOnEsc"
			no-close-on-backdrop
			:hide-header-close="hideHeaderClose"
		>
			<b-col><k-info-box type="error" :info="error" /></b-col>
			<slot name="content"></slot>
			<div v-if="message">{{ message }}</div>
			<template #modal-footer="{ ok, cancel }">
				<slot name="footer" @ok="ok" @cancel="cancel"></slot>
			</template>
		</b-modal>
	</div>
</template>

<script>
import KInfoBox from "../ui/KInfoBox.vue";

export default {
	components: { KInfoBox },
	props: {
		id: {
			type: String
		},
		title: {
			type: String
		},
		okTitle: {
			type: String
		},
		okVariant: {
			type: String
		},
		cancelTitle: {
			type: String
		},
		cancelVariant: {
			type: String
		},
		size: {
			type: String
		},
		okOnly: {
			type: Boolean,
			default: false
		},
		error: {
			type: Object
		},
		okDisabled: {
			type: Boolean,
			default: false
		},
		cancelDisabled: {
			type: Boolean,
			default: false
		},
		message: {
			type: String
		},
		hideFooter: {
			type: Boolean,
			default: false
		},
		customClass: {
			type: String,
			default: ""
		},
		onOk: {
			type: Function,
			default: () => {}
		},
		noCloseOnEsc: {
			type: Boolean,
			default: false
		},
		hideHeaderClose: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		emitOk: function (e) {
			this.onOk();
			this.$emit("ok", () => {
				e.preventDefault();
			});
		},
		emitHidden: function () {
			this.$emit("hidden");
		},
		emitCancel: function () {
			this.$emit("cancel");
		},
		emitBeforeHide: function (e) {
			this.$emit("beforeHide", e);
		}
	}
};
</script>

<style>
.hideButtons .responseRequirementModal___BV_modal_footer_ .btn-primary {
	display: none;
}
.hideButtons .responseRequirementModal___BV_modal_footer_ .btn-secondary {
	display: none;
}
</style>
